export function getAmountDiff(
  amount: number,
  sub_total: number,
  tax: number
): number {
  return Math.abs(amount - (sub_total + tax))
}